import Maps from '../core/core__Maps/Maps';

export default class Map{
    constructor(config){
        this.mapConfig = {};
        this.lang = () => document.getElementsByTagName('html')[0].getAttribute('lang');
        this.isPredefined = config.isPredefined || false;
    }
    
    runMaps(config){
       const gMaps = new Maps(config);
    }
}


// WEBPACK FOOTER //
// ./components/Map/Map.js